import React from 'react';
import ReactDOM from 'react-dom';
import Home from './pages/home/Home';
import './assets/styles/index.scss';

ReactDOM.render(<Home />, document.getElementById('root'));
